import { useAuthStore } from '@/stores/auth.store';
import { packPublishLabels, type PackPublishLabels } from './packPublishLabels';

/**
 * Libellés du bouton « Publier sur git » d'un éditeur de pack pour l'utilisateur connecté : même droit
 * que la publication directe d'Envoyer (« Publications » en écriture, admin du projet ou admin).
 */
export function usePackPublishLabels(): PackPublishLabels {
  const canPublish = useAuthStore((s) => s.canWrite)('config.requests');
  return packPublishLabels(canPublish);
}
